import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { WebWorkerMessageHandlerService } from 'src/app/modules/core/web-workers/web-worker-message-handler.service';
import {
  SET_MASSNOTIFICATION_ENVIRONMENT,
  SET_MASSNOTIFICATION_AUTH_TOKEN,
  SUBSCRIBE_TO_MASSNOTIFICATION,
  UNSUBSCRIBE_TO_MASSNOTIFICATION,
  MASSNOTIFICATION_UPDATED_MESSAGE
} from './massnotification-messages.model';
import * as fromAuth from 'src/app/modules/authentication/store/auth';
import { LoggerService } from 'src/app/modules/core/services/logger/logger.service';
import { UpdateMassNotificationHandler } from './client-handlers/update-mass-notification.handler';

@Injectable({
  providedIn: 'root'
})
export class MassNotificationWorkerService implements OnDestroy {
  isActive: boolean;
  worker: Worker;
  messageHandlerService: WebWorkerMessageHandlerService = new WebWorkerMessageHandlerService();

  constructor(private store$: Store<any>, private loggerService: LoggerService) {
    this.init();
  }

  ngOnDestroy(): void {
    this.worker?.terminate();
  }

  init(): void {
    if (this.worker === undefined || typeof Worker !== 'undefined') {
      // Create a new worker
      const worker = new Worker(new URL('./massnotification.worker', import.meta.url), { type: 'module' });
      this.worker = worker;
    }

    // store listing for messages
    this.worker.onmessage = message => {
      this.messageHandlerService.handleMessage(message.data.messageName, message.data.data);
    };

    // pass the environment vars to the webworker
    const environment = window['__env'];
    this.sendMessage(SET_MASSNOTIFICATION_ENVIRONMENT, { environment });

    // Subscribe to token changes
    this.store$.select(fromAuth.selectToken).subscribe(t => {
      if (!!t) {
        this.sendMessage(SET_MASSNOTIFICATION_AUTH_TOKEN, { token: t.access_token });
      }
    });

    //
    // register message handlers here
    //
    this.messageHandlerService.registerHandler(MASSNOTIFICATION_UPDATED_MESSAGE, new UpdateMassNotificationHandler(this.store$, this.loggerService));
  }

  subscribeToMassNotificationUpdate(notificationUId: string) {
    this.sendMessage(SUBSCRIBE_TO_MASSNOTIFICATION, notificationUId);
  }

  unsubscribeToMassNotificationUpdate(notificationUId?: string) {
    this.sendMessage(UNSUBSCRIBE_TO_MASSNOTIFICATION, notificationUId);
  }

  sendMessage(messageName: string, data?: any): void {
    this.worker?.postMessage({ messageName, data });
  }
}
